(function () {
    "use strict";

    function handleBadges() {
        document.querySelectorAll(".vton-badge-wrapper").forEach((badge) => {

            // Find the nearest product card
            const card = badge.closest("product-card");

            // Not inside a product card? Remove it.
            if (!card) {
                badge.remove();
                return;
            }

            // Find image container
            const container =
                card.querySelector(".product-card__media") ||
                card.querySelector(".product-card__figure");

            if (!container) return;

            // Move badge into image
            if (badge.parentElement !== container) {
                container.appendChild(badge);
            }

            container.style.position = "relative";

            Object.assign(badge.style, {
                position: "absolute",
                top: "12px",
                left: "12px",
                right: "auto",
                bottom: "auto",
                inset: "unset",
                margin: "0",
                zIndex: "999",
                transform: "none"
            });
        });
    }

    handleBadges();

    new MutationObserver(handleBadges).observe(document.body, {
        childList: true,
        subtree: true
    });

    setInterval(handleBadges, 1000);
})();